import type { RootState } from '@/redux/RootReducer';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';
import type { FC } from 'react';
import { useSelector } from 'react-redux';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentCategoryType } from '../../hooks';

interface ShipmentCategoryTypeSelectProps
  extends Pick<FormItemProps, 'rules' | 'name' | 'colon'>,
    Pick<SelectProps, 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  singleLineMode?: boolean;
  inverMode?: boolean;
  onChange: (value?: unknown) => void;
  disableValidation?: boolean;
}

export const ShipmentCategoryTypeSelect: FC<ShipmentCategoryTypeSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.categoryType.placeholder'),
  label = i18n.t('translation:default.fields.categoryType.label'),
  rules = [],
  name,
  editMode,
  margin,
  singleLineMode,
  inverMode,
  colon,
  onChange,
  disableValidation = false,
}) => {
  const { selectedCompany } = useSelector((state: RootState) => state.auth);
  const { data = [], isLoading } = useGetShipmentCategoryType({ CustomerKey: selectedCompany.companyId as string });

  return (
    <FormSelectBox
      loading={isLoading}
      options={data}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      singleLineMode={singleLineMode}
      inverMode={inverMode}
      colon={colon}
      onChange={onChange}
      disableValidation={disableValidation}
    />
  );
};
